module.exports = __webpack_public_path__ + "static/media/productos_otros_pepita_blanca.ca5c8d7f.jpg";